import { useContext, useEffect, useReducer, useState } from "react";
import { cardDivStyle } from "../../styles/styles";
import { AppContext } from "../../context/AppProvider";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import { basicReducer } from "../../util/General";
import {
  FileInjestButton,
  FileUploadButton,
  ImageInjestButton,
} from "../../components/FileUpload";

const TeamPage = () => {
  const appState = useContext(AppContext);
  const [userTeams, userTeamsAction] = useReducer(basicReducer, {});
  const [selection, setSelection] = useState();
  const [firstRun, setFirstRun] = useState(true);
  const [joinableTeams, joinableTeamAction] = useReducer(basicReducer, {});
  const [votingCategories, setVotingCategories] = useState();
  const [joinTeamSelection, setJoinTeamSelection] = useState();
  const [joinTeamRequested, setJoinTeamRequested] = useState();

  const handleJoinableSnapshot = (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        joinableTeamAction({
          type: "update",
          key: change.doc.id,
          value: change.doc.data(),
        });
      }
      if (change.type === "modified") {
        joinableTeamAction({
          type: "update",
          key: change.doc.id,
          value: change.doc.data(),
        });
      }
      if (change.type === "removed") {
        joinableTeamAction({
          type: "remove",
          key: change.doc.id,
        });
      }
    });
  };

  const handleUserTeamSnapshot = (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        userTeamsAction({
          type: "update",
          key: change.doc.id,
          value: change.doc.data(),
        });
      }
      if (change.type === "modified") {
        userTeamsAction({
          type: "update",
          key: change.doc.id,
          value: change.doc.data(),
        });
      }
      if (change.type === "removed") {
        userTeamsAction({
          type: "remove",
          key: change.doc.id,
        });
      }
    });
  };

  useEffect(() => {
    if (selection === "join") {
      if (appState.firebase && appState.firebase.db) {
        console.log("Subscribing to joinable team list");
        const joinableQuery = query(
          collection(appState.firebase.db, "teams"),
          where("joinable", "==", true)
        );
        const unSub = onSnapshot(joinableQuery, handleJoinableSnapshot);
        appState.setLive("joinable_unsub", unSub);
      }
    } else if (appState.live.joinable_unsub) appState.live.joinable_unsub();
  }, [selection]);

  useEffect(() => {
    setFirstRun(false);
    if (firstRun) {
      if (appState.firebase && appState.firebase.db) {
        const docRef = doc(
          appState.firebase.db,
          "contest_categories",
          "9rNjsuhhucBUnbt1On0r"
        );

        getDoc(docRef)
          .then((docSnap) => {
            setVotingCategories(docSnap.data());
          })
          .catch((err) => {
            window.alert(`Error loading categories ${err}`);
          });

        console.log("Subscribing to user team list");
        const userTeamsQuery = query(
          collection(appState.firebase.db, "teams"),
          where("member_uids", "array-contains", appState.live.uid)
        );
        //if (appState.live.userteam_unsub) appState.live.userteam_unsub();
        const unSub = onSnapshot(userTeamsQuery, handleUserTeamSnapshot);
        appState.setLive("userteam_unsub", unSub);
      }
    }
  }, []);

  const handleJoinableTeamChoice = (e) => {
    setJoinTeamSelection(e.target.value);
  };

  const handleJoinRequestClick = (e) => {
    setJoinTeamRequested(true);
    if (joinTeamSelection && appState.firebase && appState.firebase.db) {
      const docRef = doc(appState.firebase.db, "teams", joinTeamSelection);
      const uploadData = {
        updated: serverTimestamp(),
        request_uids: arrayUnion(appState.live.uid),
      };
      setDoc(docRef, uploadData, { merge: true })
        .then((docRef) => {
          console.log("Team request updated", docRef);
          setJoinTeamSelection(undefined);
          setJoinTeamRequested(false);
          setSelection(undefined);
        })
        .catch((err) => {
          window.alert(`Request failed\n${err}`);
          setJoinTeamRequested(false);
        });
    }
  };

  const handleRegisterSave = (teamId) => {
    setSelection(undefined);
  };

  const teamFound = Object.keys(userTeams).length > 0;
  const requestEnabled = joinTeamSelection && !joinTeamRequested;

  return (
    <>
      {Object.keys(userTeams).map((teamId) => {
        return (
          <TeamCard
            team_id={teamId}
            team_data={userTeams[teamId]}
            categories={votingCategories}
          />
        );
      })}
      {!teamFound && (
        <>
          <div style={cardDivStyle}>
            <h1>Get Started</h1>
            <p>
              We couldn't find you in a team! You can register a team or join an
              existing one.
              <br />
              Registering or joining a team in the app lets you update your name
              and photo, but not all members are required to join in the app!
            </p>
            <button
              className="btn btn-success"
              onClick={() => {
                setSelection("join");
              }}
            >
              Join Team
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              onClick={() => {
                setSelection("register");
              }}
            >
              Register Team
            </button>
          </div>
          {selection === "join" && (
            <div style={cardDivStyle}>
              <h2>Join Team</h2>
              <p>
                Select your team from the list. The list should refresh
                automatically.
                <br />
                If your team has been registerd but is not showing, please make
                sure "joinable" is turned on with a member of your team who is
                already joined
              </p>

              <h3>
                Teams &nbsp;
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </h3>
              {Object.keys(joinableTeams).map((team_id) => {
                const team_data = joinableTeams[team_id];
                const already_requested =
                  team_data.request_uids &&
                  team_data.request_uids.includes(appState.live.uid);
                const already_member =
                  team_data.member_uids &&
                  team_data.member_uids.includes(appState.live.uid);
                return (
                  <div className="form-check" key={`joinable_${team_id}`}>
                    <input
                      className="form-check-input"
                      type="radio"
                      value={team_id}
                      name={
                        already_requested || already_member
                          ? null
                          : "join_team_selection"
                      }
                      disabled={already_requested || already_member}
                      checked={
                        joinTeamSelection === team_id ||
                        already_requested ||
                        already_member
                      }
                      id={`joinable_${team_id}`}
                      onChange={handleJoinableTeamChoice}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`joinable_${team_id}`}
                    >
                      <span
                        style={
                          already_requested || already_member
                            ? { textDecoration: "line-through" }
                            : {}
                        }
                      >
                        {team_data.team_name}
                      </span>

                      {(team_data.team_members_auto ||
                        team_data.team_members) && (
                        <>
                          <br />
                          <em
                            style={
                              already_requested || already_member
                                ? { textDecoration: "line-through" }
                                : {}
                            }
                          >
                            {team_data.team_members_auto ||
                              team_data.team_members}
                          </em>
                        </>
                      )}
                      {already_requested && (
                        <>
                          <br />
                          <span>
                            (You have already requested access to this team)
                          </span>
                        </>
                      )}
                      {already_member && (
                        <>
                          <br />
                          <span>(You are already a member of this team)</span>
                        </>
                      )}
                    </label>
                  </div>
                );
              })}
              <br />
              <button
                className="btn btn-success"
                onClick={handleJoinRequestClick}
                disabled={!requestEnabled}
              >
                Request Join
              </button>
            </div>
          )}
          {selection === "register" && (
            <TeamCard
              categories={votingCategories}
              onSave={handleRegisterSave}
            />
          )}
        </>
      )}
    </>
  );
};

const TeamCard = ({ team_id, team_data, onSave, categories }) => {
  const appState = useContext(AppContext);
  const [changedValues, dispatchChangedAction] = useReducer(basicReducer, {});
  const [userCache, dispatchUserCacheAction] = useReducer(basicReducer, {});
  const [userCacheList, setUserCacheList] = useState([]);
  const [saveInProgress, setSaveInProgress] = useState();
  const [tempImage, setTempImage] = useState();
  //const [changedArrays, dispatchArrayAction] = useReducer(basicReducer, {});
  //'team_name','team_members','team_members_auto','member_uids','created','updated','car_photo','registered_for','joinable','request_uids'
  /*const {
    team_name,
    team_members,
    team_members_auto,
    member_uids,
    car_photo,
    registered_for,
    joinable,
    request_uids,
  } = team_data || {};*/
  const derivedData = { ...(team_data || {}), ...changedValues };
  //const mappedData = {};
  //["registered_for", "member_uids", "request_uids"].forEach((key) => {
  //Then modify if present in existing data
  //Then modify if in the changed array
  /*if (!mappedData[key]) mappedData[key] = {};
    const idList = derivedData[key];
    if (idList) {
      idList.forEach((selectedId) => (mappedData[key][selectedId] = true));
    }
    const changedMap = changedArrays[key];
    if (changedMap) {
      Object.keys(changedMap).forEach((changedId) => {
        mappedData[key][changedId] = changedMap[changedId];
      });
    }*/
  //This worked, but trying something different
  /*  const idList = derivedData[key] || [];
    const changedMap = changedArrays[key];
    if (changedMap) {
      const newIdList = [];
      idList.forEach((someId) => {
        if (!someId in changedMap) newIdList.push(someId);
      });
      Object.keys(changedMap).forEach((someId) => {
        if (changedMap[someId]) newIdList.push(someId);
      });
      derivedData[key] = newIdList;
    }*/
  //});

  const setInitialData = () => {
    if (!team_id) {
      let initialChanges = {
        team_members_auto: appState.live.user_nickname,
      };

      //Basically if voting then default true if no existing data
      if (categories && categories.voting) {
        initialChanges["registered_for"] = [];
        Object.keys(categories.voting).forEach((voting_key) => {
          initialChanges.registered_for.push(voting_key);
        });
      }

      dispatchChangedAction({
        type: "merge",
        data: initialChanges,
      });
    }
  };

  useEffect(setInitialData, [team_id]);

  //Cache user nicknames
  useEffect(() => {
    let neededUsers = [];
    if (derivedData.member_uids) neededUsers = derivedData.member_uids;
    if (derivedData.request_uids)
      neededUsers = [...neededUsers, ...derivedData.request_uids];

    setUserCacheList(neededUsers);
  }, [derivedData.member_uids, derivedData.request_uids]);

  useEffect(() => {
    userCacheList.forEach((userId) => {
      if (!(userId in userCache)) {
        dispatchUserCacheAction({
          type: "update",
          key: userId,
          value: { status: "attempted" },
        });
        if (appState.firebase && appState.firebase.db) {
          const userRef = doc(appState.firebase.db, "users", userId);
          console.log("Making request for", userId);
          getDoc(userRef)
            .then((userDoc) => {
              dispatchUserCacheAction({
                type: "update",
                key: userId,
                value: { status: "loaded", data: userDoc.data() },
              });
            })
            .catch((err) => {
              dispatchUserCacheAction({
                type: "update",
                key: userId,
                value: { status: "failed" },
              });
            });
        }
      }
    });
  }, [userCacheList]);

  const getEditActionCallback = (fieldKey) => {
    return (e) => {
      const newValue = ["checkbox", "radio"].includes(e.target.type)
        ? e.target.checked
        : e.target.value;
      if (team_data && newValue === team_data[fieldKey])
        dispatchChangedAction({
          type: "remove",
          key: fieldKey,
        });
      else
        dispatchChangedAction({
          type: "update",
          key: fieldKey,
          value: newValue,
        });
    };
  };

  const handlePhotoUpload = (photoData) => {
    dispatchChangedAction({
      type: "update",
      key: "car_photo",
      value: photoData,
    });
  };

  const getArrayActionCallback = (fieldKey, changeId) => {
    return (e) => {
      let isIncluded = e.target.checked;
      let newArray = [];
      if (derivedData[fieldKey]) newArray = [...derivedData[fieldKey]];

      if (isIncluded) {
        if (!newArray.includes(changeId)) newArray.push(changeId);
      } else {
        let changedIndex = newArray.indexOf(changeId);
        if (changedIndex > -1) {
          newArray.splice(changedIndex, 1);
        }
      }

      let changeNeeded = false;
      if (team_data && team_data[fieldKey]) {
        team_data[fieldKey].forEach((someKey) => {
          if (!newArray.includes(someKey)) {
            changeNeeded = true;
          }
        });
        newArray.forEach((someKey) => {
          if (!team_data[fieldKey].includes(someKey)) {
            changeNeeded = true;
          }
        });
      } else if (newArray.length > 0) changeNeeded = true;

      if (changeNeeded) {
        dispatchChangedAction({
          type: "update",
          key: fieldKey,
          value: newArray,
        });
      } else {
        dispatchChangedAction({
          type: "remove",
          key: fieldKey,
        });
      }

      /*let newMap = {};
      if (changedArrays[fieldKey]) newMap = { ...changedArrays[fieldKey] };
      newMap[changeId] = e.target.checked;
      dispatchArrayAction({
        type: "update",
        key: fieldKey,
        value: newMap,
      });*/
    };
  };

  const getMemberChangeCallback = (userId) => {
    return (e) => {
      let action = undefined;

      if (e.target.checked) action = "add";
      else action = "remove";

      let newMemberArray = [];
      let newRequestArray = [];
      if (derivedData.member_uids)
        newMemberArray = [...derivedData.member_uids];
      if (derivedData.request_uids)
        newRequestArray = [...derivedData.request_uids];

      if (action === "add" && userId) {
        newMemberArray.push(userId);
        let requestIndex = newRequestArray.indexOf(userId);
        if (requestIndex > -1) {
          newRequestArray.splice(requestIndex, 1);
        }
      }
      if (action === "remove" && userId) {
        newRequestArray.push(userId);
        let memberIndex = newMemberArray.indexOf(userId);
        if (memberIndex > -1) {
          newMemberArray.splice(memberIndex, 1);
        }
      }

      let memberChangeNeeded = false;
      if (team_data && team_data.member_uids) {
        team_data.member_uids.forEach((someKey) => {
          if (!newMemberArray.includes(someKey)) {
            memberChangeNeeded = true;
          }
        });
        newMemberArray.forEach((someKey) => {
          if (!team_data.member_uids.includes(someKey)) {
            memberChangeNeeded = true;
          }
        });
      } else if (newMemberArray.length > 0) memberChangeNeeded = true;

      if (memberChangeNeeded) {
        dispatchChangedAction({
          type: "update",
          key: "member_uids",
          value: newMemberArray,
        });
      } else {
        dispatchChangedAction({
          type: "remove",
          key: "member_uids",
        });
      }

      let requestChangeNeeded = false;
      if (team_data && team_data.request_uids) {
        team_data.request_uids.forEach((someKey) => {
          if (!newRequestArray.includes(someKey)) {
            requestChangeNeeded = true;
          }
        });
        newRequestArray.forEach((someKey) => {
          if (!team_data.request_uids.includes(someKey)) {
            requestChangeNeeded = true;
          }
        });
      } else if (newRequestArray.length > 0) requestChangeNeeded = true;

      if (requestChangeNeeded) {
        dispatchChangedAction({
          type: "update",
          key: "request_uids",
          value: newRequestArray,
        });
      } else {
        dispatchChangedAction({
          type: "remove",
          key: "request_uids",
        });
      }
    };
  };

  const handleSaveClicked = (e) => {
    setSaveInProgress(true);

    let uploadData = { ...changedValues, updated: serverTimestamp() };

    if (appState.firebase && appState.firebase.db) {
      if (team_id) {
        const docRef = doc(appState.firebase.db, "teams", team_id);
        setDoc(docRef, uploadData, { merge: true }).then(() => {
          setSaveInProgress(false);
          dispatchChangedAction({ type: "reset" });
          if (onSave) onSave({ id: team_id, data: uploadData });
        });
      } else {
        uploadData.created = serverTimestamp();
        uploadData.member_uids = [appState.live.uid];
        const collectionRef = collection(appState.firebase.db, "teams");
        addDoc(collectionRef, uploadData)
          .then((docRef) => {
            setSaveInProgress(false);
            dispatchChangedAction({ type: "reset" });
            setInitialData();
          })
          .catch((err) => {
            window.alert(`Saving failed ${err}`);
          });
      }
    } else {
      window.alert(`Save failed because firebase is not set up correctly`);
      setSaveInProgress(false);
    }
  };

  const handleDiscardClicked = () => {
    if (
      window.confirm(
        "Are you sure you would like to continue? Changes will be reverted."
      )
    ) {
      dispatchChangedAction({ type: "reset" });
      setInitialData();
    }
  };

  const showSave = changedValues && Object.keys(changedValues).length > 0;

  const enableSave =
    derivedData.team_name &&
    derivedData.team_name.trim().length > 0 &&
    !saveInProgress;

  return (
    <div style={cardDivStyle}>
      <h3>{team_id ? "Edit Team" : "Register Team"}</h3>
      <label htmlFor="team_name" className="form-label">
        Car Name*
      </label>
      <input
        className="form-control"
        name="team_name"
        id="team_name"
        type="text"
        value={derivedData.team_name || ""}
        onChange={getEditActionCallback("team_name")}
      />
      <hr />
      <label>Car Photo</label>
      <br />
      {derivedData.car_photo && (
        <div
          style={{
            maxWidth: "100%",
            maxHeight: "50vh",
            height: "50vh",
            width: "50%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            style={{ height: "100%", width: "100%", objectFit: "contain" }}
            src={derivedData.car_photo}
          />
        </div>
      )}
      <ImageInjestButton onBase64={handlePhotoUpload}>
        Upload Photo
      </ImageInjestButton>
      <hr />
      <label htmlFor="team_members" className="form-label">
        Team Members <br />
        <em>
          &nbsp;&nbsp;&nbsp;&nbsp;Manually edit to include those who are not
          using the site.
          {/*<br />
          &nbsp;&nbsp;&nbsp;&nbsp;Leave blank or erase to auto-generate from
          access list*/}
        </em>
      </label>
      <input
        className="form-control"
        name="team_members"
        id="team_members"
        type="text"
        value={derivedData.team_members || derivedData.team_members_auto}
        onChange={getEditActionCallback("team_members")}
      />
      <hr />
      <label>Team Access</label>
      <br />
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={derivedData.joinable || false}
          value={derivedData.joinable || false}
          onChange={getEditActionCallback("joinable")}
          id={"team_joinable"}
        />
        <label className="form-check-label" htmlFor={"team_joinable"}>
          Allow others to request access
        </label>
      </div>
      {derivedData.member_uids && (
        <>
          <hr />
          <label>Team Access List</label>
          <br />
          {derivedData.member_uids.map((userId) => {
            return (
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={true}
                  onChange={getMemberChangeCallback(userId)}
                  id={`member_${userId}`}
                />
                <label
                  className="form-check-label"
                  htmlFor={`member_${userId}`}
                >
                  {(userCache[userId] &&
                    userCache[userId].data &&
                    userCache[userId].data.user_nickname) || (
                    <em>"(No Name)"</em>
                  )}
                </label>
              </div>
            );
          })}
        </>
      )}
      {derivedData.request_uids && (
        <>
          <hr />
          <label>Access Request List</label>
          <br />
          {derivedData.request_uids.map((userId) => {
            return (
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={false}
                  onChange={getMemberChangeCallback(userId)}
                  id={`member_${userId}`}
                />
                <label
                  className="form-check-label"
                  htmlFor={`member_${userId}`}
                >
                  {(userCache[userId] &&
                    userCache[userId].data &&
                    userCache[userId].data.user_nickname) || (
                    <em>"(No Name)"</em>
                  )}
                </label>
              </div>
            );
          })}
        </>
      )}
      {categories && categories.voting && (
        <>
          <hr />
          <label>Registered Voting Categories:</label>
          {Object.keys(categories.voting).map((category_key) => {
            return (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={
                    (derivedData.registered_for &&
                      derivedData.registered_for.includes(category_key)) ||
                    false
                  }
                  onChange={getArrayActionCallback(
                    "registered_for",
                    category_key
                  )}
                  id={`voting_${category_key}`}
                />
                <label
                  className="form-check-label"
                  htmlFor={`voting_${category_key}`}
                >
                  {categories.voting[category_key].title}
                  {categories.voting[category_key].desc && (
                    <>
                      <br />
                      <span style={{ marginLeft: "5px" }}>
                        {categories.voting[category_key].desc}
                      </span>
                    </>
                  )}
                </label>
              </div>
            );
          })}
        </>
      )}
      {categories && categories.other && (
        <>
          <hr />
          <label>Registered Racing Categories:</label>
          {Object.keys(categories.other).map((category_key) => {
            return (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={
                    (derivedData.registered_for &&
                      derivedData.registered_for.includes(category_key)) ||
                    false
                  }
                  onChange={getArrayActionCallback(
                    "registered_for",
                    category_key
                  )}
                  id={`other_${category_key}`}
                />
                <label
                  className="form-check-label"
                  htmlFor={`voting_${category_key}`}
                >
                  {categories.other[category_key].title}
                  {categories.other[category_key].desc && (
                    <>
                      <br />
                      <em>{categories.other[category_key].desc}</em>
                    </>
                  )}
                </label>
              </div>
            );
          })}
        </>
      )}
      {showSave && (
        <>
          <hr />
          <button onClick={handleDiscardClicked} className="btn btn-danger">
            Discard Changes
          </button>
          &nbsp;
          <button
            disabled={!enableSave}
            onClick={handleSaveClicked}
            className="btn btn-success"
          >
            {saveInProgress ? "Saving..." : "Save Changes"}
          </button>
        </>
      )}
    </div>
  );
};

export { TeamPage };
